import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-increase-trial',
  templateUrl: './increase-trial.component.html',
  styleUrls: ['./increase-trial.component.scss']
})
export class IncreaseTrialComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<IncreaseTrialComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit() {

    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }
}
